import * as types from './actionTypes';

const initialState = {
  auditPetitions: [],
  audits: [],
  error: null,
  reviewError: null,
  createError: null,
  assignError: null,
  loadingAudits: {},
};

export const auditsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_AUDITS_REQUEST:
      return {
        ...state,
      };
    case types.GET_AUDITS_SUCCESS:
      return {
        ...state,
        auditPetitions: action.payload.data || [],
        audits: action.payload.data?.[0]?.audits || [],
      };
    case types.GET_AUDITS_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case types.REVIEW_AUDIT_REQUEST:
      return {
        ...state,
        loadingAudits: {
          ...state.loadingAudits,
          [action.payload]: true,
        },
      };
    case types.REVIEW_AUDIT_SUCCESS:
      return {
        ...state,
        audits: state.audits.filter((audit) => audit.id !== action.payload),
        loadingAudits: {
          ...state.loadingAudits,
          [action.payload]: false,
        },
      };
    case types.REVIEW_AUDIT_FAILURE:
      return {
        ...state,
        reviewError: action.error,
        loadingAudits: {
          ...state.loadingAudits,
          [action.payload]: false,
        },
      };

    case types.CREATE_AUDIT_REQUEST:
      return {
        ...state,
        createError: null,
      };
    case types.CREATE_AUDIT_SUCCESS:
      return {
        ...state,
        audits: [...state.audits, action.payload.data],
      };
    case types.CREATE_AUDIT_FAILURE:
      return {
        ...state,
        createError: action.error,
      };

    case types.ASSIGN_AUDITS_REQUEST:
      return {
        ...state,
        assignError: null,
      };
    case types.ASSIGN_AUDITS_SUCCESS:
      return {
        ...state,
      };
    case types.ASSIGN_AUDITS_FAILURE:
      return {
        ...state,
        assignError: action.error,
      };
    case types.DELETE_SIGNATORY_AUDITS_REQUEST:
      return {
        ...state,
      };
    case types.DELETE_SIGNATORY_AUDITS_SUCCESS:
      return {
        ...state,
        audits: state.audits.filter((audit) => audit.signatory_id !== action.payload),
      };

    default:
      return state;
  }
};

export default auditsReducer;
